import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import FormRow from '../../../app/components/FormRow';
import TeamSelector from '../Selects/TeamSelector';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { Option } from '../Selects/Selector';
import {
  GetExcelRowDto,
  GetTeamDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { usePokCore } from '../../../common/hooks/usePokCore';

export const getExcelRowTeamName = (d: GetExcelRowDto) =>
  d.specialistTeamName ?? d.deliveryTeamName;

interface SpecialistTeamMapperFormProps {
  specialistTeamId?: string;
  specialistTeamName?: string;
  candidateTeamIds: string[];
  companyId?: string; //gdy pozycja nie ma zespołów specjalistycznych
  aggregatedRows: boolean;
  handleUpdate: (
    newSpecialistTeamId: string,
    newSpecialistTeamName: string,
  ) => void;
}

export const SpecialistTeamMapperForm: React.FC<
  SpecialistTeamMapperFormProps
> = props => {
  const [newSpecialistTeam, setNewSpecialistTeam] = useState<
    { id: string | undefined; name?: string } | undefined
  >({ id: props.specialistTeamId, name: props.specialistTeamName });
  const [candidateTeams, setCandidateTeams] = useState<GetTeamDto[]>([]);
  const [show, setShow] = useState(false);
  const { t, tk } = useTranslation('projectLng');
  const pok = usePokCore();

  useEffect(() => {
    setNewSpecialistTeam({
      id: props.specialistTeamId,
      name: props.specialistTeamName,
    });
  }, [props.specialistTeamId, props.specialistTeamName, show]);

  useEffect(() => {
    let mounted = true;
    void Promise.all(
      props.candidateTeamIds.map(id => pok.teams.getById(id).catch(() => null)),
    ).then(teams => {
      if (mounted) {
        setCandidateTeams(
          teams.filter((team): team is GetTeamDto => !!team && team.active),
        );
      }
    });
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.candidateTeamIds.join(',')]);

  const updateParameter = () => {
    props.handleUpdate(
      newSpecialistTeam?.id || '',
      newSpecialistTeam?.name || '',
    );
    setShow(false);
  };

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShow(false);
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShow(true);
  };

  const ActionIcon = props.specialistTeamName
    ? Icon.ArrowRepeat
    : Icon.PlusCircle;
  return (
    <>
      {props.specialistTeamName ?? `[${t(tk.estimates.lack)}]`}
      {props.aggregatedRows ? (
        <></>
      ) : (
        <OverlayTrigger
          overlay={<Tooltip>{t(tk.estimates.changeParam)}</Tooltip>}
          trigger={['hover', 'hover']}
        >
          <Button
            className="py-0 btn-link btn-transparent"
            onClick={handleClick}
          >
            <ActionIcon size={18} className="icon-in-cell" />
          </Button>
        </OverlayTrigger>
      )}
      {show && (
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
        <div onClick={e => e.stopPropagation()}>
          <Modal
            onHide={() => setShow(false)}
            show={show}
            centered={true}
            keyboard={true}
            backdrop="static"
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>{t(tk.estimates.chooseParam)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form className="d-grid gap-3">
                <FormRow
                  controlId="specialistTeam"
                  label={t(tk.estimates.deliveryTeam)}
                >
                  <TeamSelector
                    companyId={props.companyId}
                    allowableValues={
                      props.companyId ? undefined : candidateTeams
                    }
                    value={newSpecialistTeam?.id || undefined}
                    clearable={true}
                    onChange={option => {
                      const newOption = option as Option;
                      setNewSpecialistTeam({
                        id: newOption?.value,
                        name: newOption?.label,
                      });
                    }}
                  />
                </FormRow>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={e => handleClose(e)}>
                {t(tk.button.close)}
              </Button>
              <Button variant="primary" onClick={updateParameter}>
                {t(tk.button.save)}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
};
